// extracted by mini-css-extract-plugin
export default {"control":"ProfileContent_control__V7uUC","flexContainer":"ProfileContent_flexContainer__lwqsR"};